export { default } from './StreamerHeader';
